import React from 'react'
import { FormLabels } from 'src/components'
import { useAppSelector } from 'src/app/hooks'
import { currencyListSelector } from 'src/features'
import { getFormatedPrice } from 'src/core/helpers'

interface PropsType {
  symbol: string,
  amount: number,
  co2_amount: number
}

const MyIntegrationListPurchaseAmountColumn: React.FC<PropsType> = ({ symbol, amount, co2_amount }) => {
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList.find(c => c?.symbol === symbol)?.code

  return (
    <div style={{ marginBottom: '-10px' }}>
      <FormLabels
        title={getFormatedPrice(amount, currencyCode)}
        subtitle={`${co2_amount?.toFixed(2)} tCO₂`}
      />
    </div>
  )
}

export default MyIntegrationListPurchaseAmountColumn
